// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8144afbb","553":"b49f09a9"}[chunkId] + ".chunk.js";
};